/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RichtextFacet from '../richtext/facet.defs.js'

const $nsid = 'app.bsky.graph.starterpack'

export { $nsid }

/** Record defining a starter pack of actors and feeds for new users. */
type Main = {
  $type: 'app.bsky.graph.starterpack'

  /**
   * Display name for starter pack; can not be empty.
   */
  name: string
  description?: string
  descriptionFacets?: RichtextFacet.Main[]

  /**
   * Reference (AT-URI) to the list record.
   */
  list: l.AtUriString
  feeds?: FeedItem[]
  createdAt: l.DatetimeString
}

export type { Main }

/** Record defining a starter pack of actors and feeds for new users. */
const main = l.record<'tid', Main>(
  'tid',
  $nsid,
  l.object({
    name: l.string({ maxGraphemes: 50, maxLength: 500, minLength: 1 }),
    description: l.optional(l.string({ maxGraphemes: 300, maxLength: 3000 })),
    descriptionFacets: l.optional(
      l.array(l.ref<RichtextFacet.Main>((() => RichtextFacet.main) as any)),
    ),
    list: l.string({ format: 'at-uri' }),
    feeds: l.optional(
      l.array(l.ref<FeedItem>((() => feedItem) as any), { maxLength: 3 }),
    ),
    createdAt: l.string({ format: 'datetime' }),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type FeedItem = {
  $type?: 'app.bsky.graph.starterpack#feedItem'
  uri: l.AtUriString
}

export type { FeedItem }

const feedItem = l.typedObject<FeedItem>(
  $nsid,
  'feedItem',
  l.object({ uri: l.string({ format: 'at-uri' }) }),
)

export { feedItem }
